export default "__VITE_ASSET__BWh1dGOW__"